import React from 'react';
import GenericSearchForm from '../GenericSearch/GenericSearchForm';

const UnitsSearchForm = (props) => {
  const fields = [
    {
      key: 'customer',
      label: 'Customer (Name or Email)',
      placeholder: 'Customer name or email',
      type: 'text',
      gridProps: { xs: 12, sm: 4, lg: 3, xl: 2 }
    },
    {
      key: 'phone_number',
      label: 'Phone number',
      placeholder: 'Phone number',
      type: 'text',
      gridProps: { xs: 12, sm: 4, lg: 2, xl: 2 }
    },
    {
      key: 'unit_number',
      label: 'Unit #',
      placeholder: 'Unit#',
      type: 'text',
      gridProps: { xs: 12, sm: 3, lg: 2, xl: 2 }
    },
    {
      key: 'license_plate',
      label: 'License Plate (LP)',
      placeholder: 'License Plate(LP)',
      type: 'text',
      gridProps: { xs: 12, sm: 4, lg: 2, xl: 2 }
    },
    {
      key: 'status',
      label: 'Status',
      type: 'select',
      options: [
        { value: '', label: 'All' },
        { value: 'active', label: 'Active' },
        { value: 'pending', label: 'Pending' },
        { value: 'archived', label: 'Archived' }
      ],
      gridProps: { xs: 12, sm: 4, lg: 2, xl: 2 }
    }
  ];

  return <GenericSearchForm {...props} fields={fields} />;
};

export default UnitsSearchForm;